import { Route, Routes } from 'react-router-dom';

import { APP_VERSION } from 'constants/appVersion';

import { Headline } from 'components/Headline';

import * as S from './Login.styles';
import { ForgotPassword } from './components/ForgotPassword';
import { LoginForm } from './components/LoginForm';
import { NewPasswordForm } from './components/NewPasswordForm';

export function LoginPage(): React.ReactElement {
  return (
    <S.Container>
      <S.Title
        tag="h1"
        scale="xl5"
        textTransform="uppercase"
        color="white"
        fontWeight="normal"
      >
        colmar
      </S.Title>

      <S.Wrapper>
        <Routes>
          <Route path="/" element={<LoginForm />} />

          <Route path="/new-password-challenge" element={<NewPasswordForm />} />

          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>

        <S.Footer>
          <Headline
            textAlign="center"
            color="borderColorDarkSecondary"
            fontWeight="light"
            scale="xs"
            fontFamily="LFT Zeno"
          >
            Copyrights © All Rights Reserved by Manifattura Mario Colombo &#38; C.
          </Headline>

          <Headline
            textAlign="center"
            color="borderColorDarkSecondary"
            fontWeight="light"
            scale="xs"
            fontFamily="LFT Zeno"
          >
            {APP_VERSION}
          </Headline>
        </S.Footer>
      </S.Wrapper>
    </S.Container>
  );
}
